import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import { Router } from "./Router";
import "./index.css";

const container = document.getElementById("root");

if (!container) {
    throw new Error("Element with ID 'root' not found");
}

const root = createRoot(container);
root.render(
    <React.StrictMode>
        <Router />
    </React.StrictMode>
);

reportWebVitals();
